import { put } from 'redux-saga/effects';
import {  outdateSearch } from 'app/actions/search-results';



export default function* onChangeForm() {
  yield put(outdateSearch());
}
